export var REQUIRED = 'required';
export var OPTIONAL = 'optional';
export var COMPLETION_MODES = [{
  value: REQUIRED,
  i18nTitleKey: 'optional_content_required'
}, {
  value: OPTIONAL,
  i18nTitleKey: 'optional_content_optional'
}];